import { Link } from "react-router-dom";
import { Building2, LogOut } from "lucide-react";
import { useTenant } from "../../contexts/TenantContext";

export const TenantShell = ({ children, wide = false }) => {
  const { config, brand, logoSrc, me, logout, to } = useTenant();
  return (
    <div className="tenant-portal min-h-screen bg-[#F7F8FA] text-neutral-900" style={{ "--tenant": brand }} data-testid="tenant-shell">
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
          <Link to={to("/")} className="flex items-center gap-3" data-testid="tenant-header-logo">
            {logoSrc ? <img src={logoSrc} alt={config.name} className="h-10 max-w-[220px] object-contain sm:h-11 sm:max-w-[260px]" />
              : <span className="flex h-10 w-10 items-center justify-center rounded-lg text-white" style={{ background: brand }}><Building2 size={20} /></span>}
            {!logoSrc && <span className="hidden text-sm font-bold sm:block" data-testid="tenant-header-name">{config.name}</span>}
          </Link>
          <div className="flex items-center gap-3 text-xs text-neutral-500">
            <span className="hidden sm:inline">Powered by <b className="text-neutral-700">Clinq</b></span>
            {me && (
              <button type="button" onClick={logout} className="inline-flex items-center gap-1 rounded-full border border-neutral-200 px-3 py-1.5 font-semibold text-neutral-700 hover:bg-neutral-50" data-testid="tenant-logout">
                <LogOut size={12} /> Sign out
              </button>
            )}
          </div>
        </div>
      </header>
      <main className={"mx-auto px-5 py-8 " + (wide ? "max-w-6xl" : "max-w-3xl")}>{children}</main>
      <footer className="mx-auto max-w-6xl px-5 pb-8 text-center text-[11px] text-neutral-400">
        {config.name} · Assessment powered by Clinq Capital Readiness · Indicative outcomes only, not {config.partner_type === "ecosystem" ? "a funding offer" : "a loan offer"}.
      </footer>
    </div>
  );
};

export const BrandButton = ({ children, className = "", ...props }) => (
  <button {...props} style={{ background: "var(--tenant)" }}
    className={"inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-bold text-white shadow-sm transition-transform hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0 " + className}>
    {children}
  </button>
);

export const STEPS = [
  { n: 1, title: "Tell us about your business" },
  { n: 2, title: "Upload your documents" },
  { n: 3, title: "We score your business" },
  { n: 4, title: "Your qualification outcome" },
];

export const ECO_STEPS = [
  { n: 1, title: "Accept the NDA" },
  { n: 2, title: "Upload your documents" },
  { n: 3, title: "Who we can connect you to" },
];

export const Stepper = ({ current, steps = STEPS }) => (
  <ol className={"mb-8 grid gap-2 " + (steps.length === 3 ? "grid-cols-3" : "grid-cols-4")} data-testid="tenant-stepper">
    {steps.map((s) => {
      const done = s.n < current, active = s.n === current;
      return (
        <li key={s.n} className="flex flex-col gap-2" data-testid={`tenant-step-${s.n}`} data-state={done ? "done" : active ? "active" : "todo"}>
          <span className="h-1.5 rounded-full" style={{ background: done || active ? "var(--tenant)" : "#E5E7EB", opacity: active ? 1 : done ? 0.6 : 1 }} />
          <span className={"text-[11px] font-semibold leading-tight " + (active ? "text-neutral-900" : "text-neutral-500")}>Step {s.n}<br /><span className="font-normal">{s.title}</span></span>
        </li>
      );
    })}
  </ol>
);

export const inputCls = "w-full rounded-lg border border-neutral-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-[var(--tenant)] focus:ring-2 focus:ring-[var(--tenant)]/20";
export const labelCls = "mb-1 block text-xs font-semibold text-neutral-600";
